import {Component, Input} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {ClassificationGroup} from "../../models/classification-group";
import {Guide} from "../../models/guide";
import {BaseError} from "../pages/base-error";
import FormUtils from "../utils/form-utils.component";

@Component({
  selector: "draggable-list-group-items",
  templateUrl: "./draggable-list-group-items.component.html",
  providers: [ToastrService],
  styles: [],
})
export class DraggableListGroupItemsComponent extends BaseError {

  public name: string;
  @Input() public guides: any[];
  @Input() public systemFields: any[];
  @Input() public formFields: Guide[] = [];
  @Input() public groups: ClassificationGroup[] = [];
  @Input() public formFieldsFilter: any[];
  @Input() public isDeterminant: boolean = false;
  @Input() public idAsSlugMode: boolean = false;

  public effectAllowed: string = "all";
  public readonly ignoredTypes: string[] = ["address", "barcode", "button", "day", "file", "form", "hidden",
    "modaledit", "mycontent", "panel", "phonenumber", "qrcode", "requirement", "resource", "selectboxes", "signature",
    "time", "url", "fileupload", "htmlelement"];
  public readonly determinantTypes: string[] = ["boolean", "classification", "radio",
    "selection", "string", "sub_catalog"];
  public readonly enumTypes: string[] = ["classification", "selection", "sub_catalog"];
  public currentDate: string = new Date().toISOString().substring(0, 10);
  public catalogIds: { value: string[] } = { value: []};

  constructor(toastr: ToastrService) {
    super(toastr);
  }

  public idFromTitle(title, id) {
    if (this.idAsSlugMode) { return id; }
    return FormUtils.generateGuideIdFromTitle(title);
  }

  public isEnum(item) {
    if (!item.type) { return false; }
    return this.isDeterminant && this.enumTypes.some((type) => type === item.type.toLowerCase());
  }

  public isHidden(item) {
    if (!item.type) { return true; }
    return this.ignoredTypes.some((type) => type === item.type.toLowerCase())
        || (this.enumTypes.some((type) => type === item.type.toLowerCase()) && !this.isDeterminant)
        || (this.determinantTypes.some((type) => type === item.type.toLowerCase()) && !this.isDeterminant);
  }

  public initDraggable(item) {
    return {
      label: this.stripHtml(item.title ? item.title : item.label),
      value: item.type === 'catalog' ? item.value.replace('_collection_item', '') : item.value,
      name: this.stripHtml(item.title),
      id: item.type === 'catalog' ? item.id.replace('_collection_item', '') : item.id,
      type: item.type,
      options: item.selections
    };
  }

  public stripHtml(value: string): string {
    if (!value) { return value; }
    return value.replace(/<[^>]*>/g, "");
  }

}
